export type FaqItem = {
  q: string;
  a: string;
};

export const faqs: FaqItem[] = [
  {
    q: "黑吃瓜网的内容一般多久更新一次？",
    a: "工作日的爆料栏目会在上午与晚间各更新一次，遇到热度较高的突发事件会随时追加。新瓜汇总每天早上整理前一天的重点话题，方便错过更新的读者一次性补齐。",
  },
  {
    q: "网站上的爆料内容来源是什么？",
    a: "我们主要整理公开可查的节目物料、官方发布信息以及网友讨论热度较高的话题，并在文中标注信息属性。对于尚未被证实的说法，我们会明确标注为「传闻」或「讨论」，不会当作既定事实呈现。",
  },
  {
    q: "如何快速找到自己关心的话题？",
    a: "可以直接在今日爆料页面使用关键词搜索，或者通过顶部的主题分类筛选。每个话题详情页底部都有相关推荐，顺着话题脉络一路读下去也很方便。",
  },
  {
    q: "可以投稿线索或者提出内容更正吗？",
    a: "当然可以。联系我们页面提供了线索投递表单，投稿时请尽量说明信息来源与可核实的关键信息。如果发现已发布内容存在事实偏差，也可以通过同一表单提交更正说明，我们会尽快复核。",
  },
  {
    q: "网站的订阅推送会发送哪些内容？",
    a: "订阅后每周会收到一次精选汇总，包含当周热度最高的话题回顾与新瓜预告，不会频繁打扰。你可以随时通过邮件中的链接退订。",
  },
  {
    q: "内容会涉及隐私信息吗？",
    a: "不会。我们不对非公开的个人信息、私人行程或未经授权的影像进行整理和传播。所有内容都围绕公开的娱乐话题展开。",
  },
];